import initMobileMenu from './MobileMenu'
import articleSlideshow from './ArticleSlideshow'
import footNotes from './FootNotes'
import articleItem from './ArticleItem'

initMobileMenu()
footNotes()
articleSlideshow()
